export const HilyteEndPoints = {
  hilytePageAccessLevel: {
    url: (company) => `/rest/v1/hilytePageAccessLevel/${company}`,
    method: `GET`,
  },

  getAllUsersPDF: {
    url: (company) => `/rest/v1/getAllUsersPDF/${company}`,
    method: `GET`,
  },

  getPDF: {
    url: (company, pdfID) => `/rest/v1/getPDF/${company}/${pdfID}`,
    method: `GET`,
  },

  getSinglePDFStatus: {
    url: (company, pdfID) => `/rest/v1/getSinglePDFStatus/${company}/${pdfID}`,
    method: `GET`,
  },

  extractSectionsFromPDF: {
    url: (company, pdfID) =>
      `/rest/v1/extractSectionsFromPDF/${company}/${pdfID}`,
    method: `POST`,
  },

  extractPortionSubmittals: {
    url: (company, pdfID) => `/rest/v1/extractPortionSubmittals/${company}`,
    method: `POST`,
  },

  updatePDFInfo: {
    url: (company, pdfID) => `/rest/v1/updatePDFInfo/${company}/${pdfID}`,
    method: `PUT`,
  },

  extractSubmittalsFromPDF: {
    url: (company, pdfID) =>
      `/rest/v1/extractSubmittalsFromPDF/${company}/${pdfID}`,
    method: `POST`,
  },

  uploadPDF: {
    url: (company) => `/rest/v1/uploadPDF/${company}`,
    method: `POST`,
  },

  deletePDF: {
    url: (company, pdfID) => `/rest/v1/deletePDF/${company}/${pdfID}`,
    method: `DELETE`,
  },
};
